import * as React from 'react'

function SvgLv(props) {
	return (
		<svg viewBox="0 0 1200 600" width="1em" height="1em" {...props}>
			<path fill="#9E3039" d="M0 0h1200v600H0" />
			<path fill="#FFF" d="M0 240h1200v120H0" />
		</svg>
	)
}

export default SvgLv
